import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SessionReportModal from "../../components/shared/SessionReportModal";
import { usePodSessionReport } from "../../hooks/usePodSessionReport";
import "./styles.css";

/**
 * A holding screen for the post-session report, and nothing else.
 *
 * The pod comes here when a session ends rather than straight to the welcome
 * screen: the report can take a while to arrive, and Welcome would spend that
 * time fetching and refreshing QR codes behind the modal, only to have them
 * expire before anyone sees them. This page has no content of its own, so
 * there is nothing to keep alive while the report is waited on.
 */
const SessionReport: React.FC = () => {
  const navigate = useNavigate();
  const { report } = usePodSessionReport();

  // Nothing to show — the report was dismissed, cleared by a new session, or
  // someone landed here directly. Hand the pod back to the welcome screen.
  useEffect(() => {
    if (!report) navigate("/", { replace: true });
  }, [report, navigate]);

  if (!report) return null;

  return (
    <div className="session-report-page">
      <SessionReportModal />
    </div>
  );
};

export default SessionReport;
